import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ClientDetailsComponent } from '../component/client-details/client-details.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet></router-outlet>`,
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'spa';
}
